import React from 'react';

const AdminUserScreen = () => {
  return <div>AdminUserScreen</div>;
};

export default AdminUserScreen;
